// The brand logomark: 8 vertical bars forming an ascending/descending speech
// contour, per design-system/system.md (heights 0.30..0.22, 26x18 viewport).
const HEIGHTS = [0.3, 0.55, 0.78, 0.95, 0.82, 0.62, 0.42, 0.22];
const BAR_W = 2;
const GAP = 1.4;
const VIEW_H = 18;

export function BrandMark({ size = 18, color = "#7A6BE0" }: { size?: number; color?: string }) {
  const scale = size / VIEW_H;
  return (
    <svg
      width={26 * scale}
      height={size}
      viewBox="0 0 26 18"
      fill="none"
      role="img"
      aria-label="Executive Interview Coach"
    >
      {HEIGHTS.map((h, i) => {
        const barH = h * VIEW_H;
        return (
          <rect
            key={i}
            x={i * (BAR_W + GAP)}
            y={(VIEW_H - barH) / 2}
            width={BAR_W}
            height={barH}
            rx={1}
            fill={color}
          />
        );
      })}
    </svg>
  );
}
